var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlagOfJapan({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 177,
    height: 118,
    viewBox: "0 0 177 118",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 177,
    height: 118,
    rx: 4,
    fill: "#F5F5F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M88.5 84C102.307 84 113.5 72.8071 113.5 59C113.5 45.1929 102.307 34 88.5 34C74.6929 34 63.5 45.1929 63.5 59C63.5 72.8071 74.6929 84 88.5 84Z",
    fill: "#FF4B55"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagOfJapan);
export default __webpack_public_path__ + "static/media/Flag_of_Japan.fcc631449a8088888a303220fc0266f5.svg";
export { ForwardRef as ReactComponent };